import intlTelInput from 'intl-tel-input';

function init() {

	var input = document.getElementById('registration-usercode'),
		submit = document.getElementById('registration-submit');
	
	if(input && submit){
		input.addEventListener("keypress", function(event) {
			if (event.key === "Enter") {
				event.preventDefault();
				submit.click();
			}
		});
	}

	const phone = document.getElementById("registration-phone");

	if(phone){
		intlTelInput(phone, {
			preferredCountries : [ 'it' ],
			nationalMode: true,
			showSelectedDialCode: true,
		});
	}

}

window.userCodeVerify = function () {

	var input = document.getElementById('registration-usercode'),
		messageInvalid = document.getElementById('registration-message-invalid'),
		messageEmpty = document.getElementById('registration-message-empty'),
		spinner = document.getElementById('registration-spinner');

		messageInvalid.classList.add('d-none');
		messageEmpty.classList.add('d-none');

	if(input) {

		var codeValue = input.value;

		if(codeValue){

			// Codice inserito.

			jQuery.ajax({
				url: window.ajaxUrl,
				type: 'post',
				data : {
					action : 'smx_get_user_by_code',
					code : codeValue,
				},
				beforeSend: function () {
	
					spinner.classList.remove('hide');
	
				},
				success : function( result ) {
	
					spinner.classList.add('hide');
			
					if(result.case == 0){
	
						// Codice non valido
		
						messageInvalid.classList.remove('d-none');
	
					} else if(result.case == 1){
	
						// Codice esistente ma non associato ad alcun utente
		
						let url = window.location.href; 
		
						if (url.indexOf('?') > -1){
							url += '&case=' + result.case + '&code=' + result.code + '&codeid=' + result.code_id;
						} else {
							url += '?case=' + result.case + '&code=' + result.code + '&codeid=' + result.code_id;
						}
		
						window.location.href = url;
		
					} else if(result.case == 2){
	
						// Codice esistente e associato ad un utente
		
						let url = result.product_url;
						window.location.href = url;
		
					}
				},
			});

		} else {

			// Codice non inserito.
			messageEmpty.classList.remove('d-none');

		}

		
	}
}

export default {
	init,
};
